import axios from '@/libs/api.request'

export const getGoods = (params) => {
  return axios.request({
    url: '/warehouse/goods',
    method: 'get',
    params
  })
}
export const getDetail = (id) => {
  return axios.request({
    url: `/warehouse/goods/${id}`,
    method: 'GET'
  })
}
export const del = (id) => {
  return axios.request({
    url: `/warehouse/goods/${id}`,
    method: 'DELETE'
  })
}
export const update = (data) => {
  return axios.request({
    url: `/warehouse/goods/${data.id}`,
    method: 'PUT',
    data
  })
}
export const add = (data) => {
  return axios.request({
    url: '/warehouse/goods',
    method: 'POST',
    data
  })
}

// 商品上架
export const goodsUp = (data) => {
  return axios.request({
    url: '/warehouse/goods/online',
    method: 'POST',
    data
  })
}
// 商品下架
export const goodsDown = (data) => {
  return axios.request({
    url: '/warehouse/goods/offline',
    method: 'POST',
    data
  })
}
